// Lib
import React from 'react';
import classNames from 'classnames';

// Styles
import './ElementCloneInstancesPopupContentInfo.scss';

const ElementCloneInstancesPopupContentInfo = (props: {
    children: React.ReactNode | React.ReactNode[];
    className?: string;
}) => {
    const { children, className } = props;

    return <div className={classNames('ElementCloneInstancesPopupContentInfo', className)}>{children}</div>;
};

export default ElementCloneInstancesPopupContentInfo;
